<template>
  <div>
    <!-- Side Navbar (mobile apps) -->
    <v-navigation-drawer app temporary v-model="sideNav">
      <v-toolbar>
        <v-app-bar app color="primary">
          <a to="/" tag="span" style="cursor: pointer">
            <div class="d-flex align-center">
              <v-img
                alt="Cloudbased Solutions"
                src="https://d2jr1lht6rcaaw.cloudfront.net/logo1-black-on-white.png"
                transition="scale-transition"
                width="130"
              />
            </div>
          </a>
        </v-app-bar>
      </v-toolbar>
      <v-divider></v-divider>
      <!-- Side Navbar links -->
      <v-list>
        <v-list-item-group color="secondary">
        <v-alert color="black">
          For cloud support mail <a href="support@cloudbased.nz">support@cloudbased.nz</a>
        </v-alert>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <!-- Horizontal Navbar -->
    <v-app-bar color="black" fixed :prominent="$vuetify.breakpoint.mdAndUp ? false : false">
      <v-app-bar-nav-icon
        @click="toggleSideNav"
        class="d-flex d-sm-none"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <div class="headline d-none d-md-none d-md-flex">
          <a to="/">
            <v-img
              alt="Cloudbased Solutions"
              class="mr-3"
              src="https://d2jr1lht6rcaaw.cloudfront.net/logo1-black-on-white.png"
              transition="scale-transition"
              :width="$vuetify.breakpoint.mdAndUp ? 150 : 110"
            />
          </a>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="d-none d-sm-flex">
        <v-alert color="black">
          For cloud support mail <a href="support@cloudbased.nz">support@cloudbased.nz</a>
        </v-alert>
      </v-toolbar-items>
      <v-spacer></v-spacer>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    sideNav: false,
    userName: "",
    userId: "",

  }),
  methods: {
    toggleSideNav() {
      this.sideNav = !this.sideNav;
    }
  }
};
</script>

<style lang="scss">
.v-toolbar__content {
  padding-top: 0 !important;
}

.x {
  primary: #ff5722;
  secondary: #1f0322;
  accent: #ffffff;
  info: #fbc02d;
  success: #78909c;
  error: #ef5350;
  warning: #651fff;
}

.y {
  primary: #af9fa5;
  secondary: #212121;
  accent: #ffffff;
  info: #fbc02d;
  success: #78909c;
  error: #ef5350;
  warning: #651fff;
}
</style>
